import request from '@/utils/request.js'
import main from '@/main'
const basePath = '/Function/CustomerTravel/';

const state = {
};

const mutations = {
};

const actions = {

  Add({commit}, view) {
    return request.PromiseCall(basePath, 'Add', view);
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/CustomerTravel/index.js